import { Heading } from "@chakra-ui/react";
import type { ReactNode } from "react";

interface SummaryGroupHeaderProps {
  children: ReactNode;
  isFirst?: boolean;
}

export const SummaryGroupHeader = ({ children, isFirst = false }: SummaryGroupHeaderProps) => (
  <Heading
    as="h4"
    fontSize="sm"
    fontWeight="semibold"
    color="smText"
    mt={isFirst ? 0 : "6"}
    mb="2"
    pt={isFirst ? 0 : "4"}
    borderTop={isFirst ? undefined : "1px solid"}
    borderColor={isFirst ? undefined : "smBorder"}
  >
    {children}
  </Heading>
);
